import { TModalIdentifier } from 'models/Modals'
import { createSelector } from 'reselect'
import { AppState } from 'store/store'

/**
 *
 * @param state - the application state
 * @returns modalsReducer - the current modals reducer
 */
export const selectModalsReducer = (state: AppState) => state.modals

/**
 * Gets the modals object from the modals reducer
 */
export const selectAllModals = createSelector(
  selectModalsReducer,
  (modalsState) => modalsState.modals
)

/**
 * Gets specific mdoal by identifier from the modals reducer
 */
export const selectModal = createSelector(
  [selectAllModals, (_, identifier: TModalIdentifier) => identifier],
  (modals, identifier) => {
    const modal = modals[identifier]
    return modal
  }
)
